<router-outlet></router-outlet>
<ngx-loading
  [show]="loading"
  [config]="{
    backdropBorderRadius: '3px',
    fullScreenBackdrop: true,
  }"
></ngx-loading>
<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
  [fullScreen]="true"
>
  <p style="font-size: 20px; color: white">Loading...</p> </ngx-spinner
><app-preloader [isLoading]="isLoading"></app-preloader>

<app-footer></app-footer>
